import {
    EDIT_TEAMS_ERROR,
    EDIT_TEAMS_LOADING, EDIT_TEAMS_SUCCESS
} from "../../../constant/actionTypes";

const editTeamReducer = (state = {}, action) => {
    switch (action.type) {
        case EDIT_TEAMS_LOADING: {
            let obj = {
                loading: true,
            };
            return obj;
        }
        case EDIT_TEAMS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response,
            };
            return obj;
        }
        case EDIT_TEAMS_ERROR: {
            let obj = {
                loading: false,
                status: action.response,
            };
            return obj;
        }
        default:
            return state;
    }
};

export default editTeamReducer;
